//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useEffect } from 'react'

import { OtStoreState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { navActions } from '@react/redux/navSlice'
import { useNavigate } from 'react-router-dom'
import { logOT } from '@shared/loggingShared'

export function SagaNavigationWrapper(props: { children: any }): React.ReactElement {
  const urlToNavigateTo = useOtSelector((state: OtStoreState) => state.navState.url)
  const dispatch = useOtDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (urlToNavigateTo) {
      logOT.info('location SAGA NAVIGATION WRAPPER', urlToNavigateTo)
      navigate(urlToNavigateTo)
      dispatch(navActions.resetURL())
    }
  }, [urlToNavigateTo])

  return <>{props.children}</>
}
